export default __webpack_public_path__ + "static/media/collection-2.525c1ea9.png";